import {PropsWithChildren} from 'react';

export function CommandAbbreviationText(props: PropsWithChildren) {
    return (
        <span style={{color: "light-dark(#414242, #5a767e)"}}>
            {props.children}
        </span>
    );
}